export const useRandomIndex = () => useState<number>('random-index', () => Math.random())